import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    const token = this.authService.getAuthToken();
    const isValid = token && !this.authService.isTokenExpired(token);

    if (!isValid) {
      console.warn('⛔ Intento de acceso sin sesión activa');
      this.authService.logout(); // 🔒 ya hace todo lo necesario
      return this.router.parseUrl('/login');
    }

    return true;
  }
}
